export default __webpack_public_path__ + "images/fedex-logo-42681.png";